var values = new Set(["normal", "nowrap", "pre-line"]);
export default (function (_a) {
    var whiteSpace = _a.whiteSpace;
    return values.has(whiteSpace) && "white-space: ".concat(whiteSpace, ";");
});
